export default __webpack_public_path__ + "static/media/Plus.8dccbe62.svg";